export default __webpack_public_path__ + "static/media/Beard_3_C2.a98629f0.svg";